//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {phoneReg,nameReg ,IDcardReg} from '@/utils/regular.js'
import {getUserinfo,insuraSubmit,insuraGatSubmit,progress} from '@/model/appointment/appointmentService';
import { store, mutations } from "../store/store"; 
import { store as observableStore } from "@/observable/store"
export default { 
    name: "reservation-home",
    data(){
        return {
            telPhone:null,
            dataPhone:null,
            userName:null,
            idCard:null,
            templ:null,
            appointment:'',
            val:'2017-10-10 12:33',
        }
    },
    computed: {
        updatePhone(){ //修改的手机号
            return store.updateTime
        },
        appoinTime(){
            return store.appoinTime
        },
        templateFlag(){
            return this.$route.query.templateFlag
        },
        storePhone(){
            return observableStore.phone
        },
    },
    watch: {
        userName(val){
            val = val.trim();
            let nameFlag = nameReg.test(val)
            this.$emit('userNameEmit',{
                name:val,
                nameFlag:nameFlag
            })
        },
        telPhone(val){
            val = val.trim();
            let phoneFlag;
            if(new RegExp("[*]").test(val)){
                phoneFlag = true
            }else{
                phoneFlag = phoneReg.test(val)
            }
            this.$emit('telPhoneEmit',{
                name:val,
                phoneFlag:phoneFlag
            })
        }, 
        idCard(val){
            val = val.trim();
            // let idCardFlag = IDcardReg.test(val)
            let idCardFlag;
            if(new RegExp("[*]").test(val)){
                idCardFlag = true
            }else{
                idCardFlag = IDcardReg(val)
            }
            this.$emit('idCardEmit',{
                name:val,
                idCardFlag:idCardFlag
            })
        },
    },
    created() {
        this.telPhone = this.storePhone
        this.uuid = this.$route.query.uuid;
        this.templ = this.templateFlag
    },
    mounted(){ 
      
    },
    methods: {
        updataPhone(){
            this.telPhone = ''
        },
    }
    
}
